import { atom } from "jotai";
import { Remittance } from "@/core/entities/deduction/remittance";
import { AppConfig } from "@/infrastructure/services/config";
import { ITableSortColumn } from "@/core/interface";

const _AppConfig = AppConfig.getInstance();
const PAGINATION_PAGE_LIMIT = _AppConfig.PAGINATION_PAGE_LIMIT;

interface RemittanceState {
  remittances: Remittance[];
  sortColumn: ITableSortColumn | null;
  isLoading: boolean;
  isRemittanceApprovalSending: boolean;
  isRemittanceApprovalChecking: boolean;
  totalCount: number;
  currentPage: number;
  currentExpandedRemittanceKey: number | null;
  pageLimit: number;
  error: Error | null;
}

const initialState: RemittanceState = {
  remittances: [],
  sortColumn: null,
  isLoading: false,
  isRemittanceApprovalSending: false,
  isRemittanceApprovalChecking: false,
  totalCount: 0,
  currentPage: 1,
  currentExpandedRemittanceKey: null,
  pageLimit: PAGINATION_PAGE_LIMIT,
  error: null,
};

// Base atoms
export const remittanceAtom = atom<RemittanceState>(initialState);

// Derived atoms for specific states
export const remittancesAtom = atom(get => get(remittanceAtom).remittances);
export const sortColumnAtom = atom(get => get(remittanceAtom).sortColumn);
export const isLoadingAtom = atom(get => get(remittanceAtom).isLoading);
export const isRemittanceApprovalSendingAtom = atom(get => get(remittanceAtom).isRemittanceApprovalSending);
export const isRemittanceApprovalCheckingAtom = atom(get => get(remittanceAtom).isRemittanceApprovalChecking);
export const errorAtom = atom(get => get(remittanceAtom).error);
export const totalCountAtom = atom(get => get(remittanceAtom).totalCount);
export const currentPageAtom = atom(get => get(remittanceAtom).currentPage);
export const pageLimitAtom = atom(get => get(remittanceAtom).pageLimit);
export const currentExpandedRemittanceKeyAtom = atom(get => get(remittanceAtom).currentExpandedRemittanceKey);
